@if (shouldShowModal) {
    <div class="modal-backdrop" (click)="onBackdropClick($event)">
        <div class="modal-content">
            <button class="close-button" (click)="onClose()">✕</button>
            <div class="modal-header">
                <img
                    class="brand-logo"
                    src="https://maxsite.b-cdn.net/Chase/Apple/Icons/applecare/AppleCare_Icon.png"
                />
            </div>
            <h1 class="modal-title">{{ currentProduct.title }}</h1>
            <p class="modal-description">{{ currentProduct.description }}</p>
            <!-- Video Section - No toggle, video only -->
            <div class="media-section">
                <div class="video-container">
                    <video class="applecare-video" #videoPlayer controls preload="metadata" [poster]="getVideoPoster()">
                        <source type="video/mp4" [src]="getVideoUrl()" />
                        Your browser doesn't support video.
                    </video>
                </div>
            </div>
            <!-- Features -->
            <div class="features-section">
                <h3>{{ currentProduct.keyFeatures.title }}</h3>
                <ul>
                    @for (feature of currentProduct.keyFeatures.items; track feature) {
                        <li>
                            {{ feature }}
                        </li>
                    }
                </ul>
            </div>
            <!-- Legal -->
            <div class="legal-section">
                <h3>{{ currentProduct.legal.title }}</h3>
                <p [innerHTML]="currentProduct.legal.content"></p>
                <p>
                    Please see the
                    <a
                        class="terms-link"
                        href="https://www.apple.com/legal/sales-support/applecare/applecareplus/"
                        rel="noopener noreferrer"
                        target="_blank"
                        >AppleCare+ Terms and Conditions</a
                    >
                    for complete details
                </p>
            </div>
        </div>
    </div>
}
